import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appNumberOnly]',
    standalone: false
})
export class NumberOnlyDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', '/'];
    const regex = /^[0-9]$/;

    if (
      allowedKeys.includes(event.key) || // Allow navigation, control keys, and '/'
      regex.test(event.key) // Allow numeric characters
    ) {
      return;
    }

    event.preventDefault(); // Block any other input
  }
}
